import React, { useEffect, useRef, useState } from "react";
import { Button, Carousel, message, Modal, Spin } from "antd";
import {
  UserSubscriptionCard,
  PasswordSection,
  Avatar,
  SubscriptionHistoryTable,
  UserM2cDetail,
  ExtendSubscription,
  StrikersList,
  Tabs,
  UserHistory,
} from "./components";
// import { ModalCloseIcon } from "pages/analytics/icons";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";
import { ModalCloseIcon } from "icons";
import { useCurrentUserContext } from "providers";
import { UseLazyApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-lazy-api-call";
import moment from "moment";
import { PersonalDetails } from "./components";
import { CaptureDetails } from "./components";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import { ReactComponent as NextIcon } from "icons/sliderNextIcon.svg";
import { ReactComponent as PreviousIcon } from "icons/sliderPreviousIcon.svg";
import { availableData } from "./constants";
import { Preview } from "components/preview-history";
import { persistedUserOrStrikerId } from "store/atom";
import { useRecoilState } from "recoil";
import { CommunicationReasons } from "../communicationReasons";
import { Activity } from "../communicationReasons/activity";

export const UserDetailModalV2 = ({
  showUserSubscDetailModal,
  handleCloseModal,
  userId,
  getUsers,
  page,
  size,
  search,
  strikerId,
}) => {
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentPlanObj, setCurrentPlanObj] = useState({});
  const [isStrikerSelected, setIsStrikerSelected] = useState(false);

  const [historyVideo, sethistoryVideo] = useState();
  const [fileId, setfileId] = useState();

  const sliderRef = useRef();
  const handlePrev = () => {
    if (currentSlide === 0 && strikerId) {
      sliderRef?.current?.goTo(1);
    } else if (currentSlide === 2 && strikerId) {
      sliderRef?.current?.goTo(currentSlide - 2);
    } else if (currentSlide === 4) {
      sliderRef?.current?.goTo(currentSlide - 2);
    } else {
      sliderRef?.current?.goTo(currentSlide - 1);
    }
  };

  const handleNext = () => {
    if (currentSlide === 0 && strikerId) {
      sliderRef?.current?.goTo(currentSlide + 2);
    } else if (currentSlide === 2) {
      sliderRef?.current?.goTo(currentSlide + 2);
    } else {
      sliderRef?.current?.next();
    }
  };
  const goTo = (slideNumber) => sliderRef?.current?.goTo(slideNumber);

  const {
    data: currentSubscription,
    isLoading: currentSubscriptionLoading,
    refetch: currentSubscriptionRefetch,
  } = UseApiCallForOldDashboardData({
    url: "get_current_subscription",
    method: "POST",
    skip: !userId,
    body: {
      userID: userId,
    },
  });

  const {
    data: userSubscriptionHistory,
    isLoading,
    refetch: subscriptionHistoryRefetch,
  } = UseApiCallInternalDashboard({
    url: "subscription/history",
    method: "POST",
    skip: !userId,

    body: {
      userId: userId,
    },
  });

  const {
    data: userDetails,
    isLoading: userDetailsLoading,
    refetch: userDetailsRefetch,
  } = UseApiCallForOldDashboardData({
    url: "get_user",
    method: "POST",
    skip: !userId,
    body: {
      userID: userId,
    },
  });

  const initialFormValues = {
    platformId: null,
    planTypeId: null,
    subscriptionExpiry: "",
    password: "",
    confirmPassword: "",
    userId: userId,
    passwordError: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);

  const [
    updateUser,
    { data: updateUserData, isLoading: userLoading, error, refetch },
  ] = UseLazyApiCallInternalDashboard({
    url: "subscription/update",
    method: "POST",
  });

  const recentPlanDetail = userSubscriptionHistory?.data?.users?.[0];
  // const [expiryAlreadyPassed, setExpiryAlreadyPassed] = useState(false);
  const [expiryDateData, setExpiryDateData] = useState({
    expiryAlreadyPassed: false,
    extendedDate: recentPlanDetail?.EndDate,
  });

  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    const { password, confirmPassword, planTypeId, platformId } = formValues;
    if (password && confirmPassword) {
      setBtnDisabled(false);
      if (planTypeId && !platformId) setBtnDisabled(true);
      if (platformId && !planTypeId) setBtnDisabled(true);
    }
    if (!password && !confirmPassword) {
      if (planTypeId && platformId) {
        setBtnDisabled(false);
      } else {
        setBtnDisabled(true);
      }
    }
  }, [formValues]);

  function addMoreDataInCurrentPlan(currentPlan) {
    if (currentPlan) {
      const isPlanExpired =
        new Date(Date.now()) > new Date(currentPlan?.expiry);

      const localCurrentPlanObj = {
        ...currentPlan,
        isPlanExpired,
        ...availableData?.[`${currentPlan?.subscriptionName}`],
      };
      setCurrentPlanObj({ ...localCurrentPlanObj });
    }
  }

  useEffect(() => {
    addMoreDataInCurrentPlan(currentSubscription?.subscription);
  }, [currentSubscription?.subscription]);

  function extendedDateHandler({ recentPlanDetail, extendedMonths, planId }) {
    if (recentPlanDetail) {
      let finalDateToExtend;
      let isExpiryPassed = false;
      const endDate = new Date(recentPlanDetail?.EndDate);
      const currentDate = new Date();

      if (currentDate > endDate) {
        //expired
        finalDateToExtend = new Date(currentDate); // Clone the current date
        finalDateToExtend.setMonth(
          finalDateToExtend.getMonth() + extendedMonths,
        );
        isExpiryPassed = true;
      } else {
        finalDateToExtend = new Date(endDate); // Clone the end date
        finalDateToExtend.setMonth(
          finalDateToExtend.getMonth() + extendedMonths,
        );
        isExpiryPassed = false;
      }
      setFormValues({
        ...formValues,
        subscriptionExpiry: moment(finalDateToExtend).format("yy-MM-DD"),
        planTypeId: planId,
      });
      setExpiryDateData({
        expiryAlreadyPassed: isExpiryPassed,
        extendedDate: finalDateToExtend.toISOString(),
      });
    }

    return null; // Handle the case where recentPlanDetail is null or undefined
  }

  useEffect(() => {
    if (recentPlanDetail) {
      setExpiryDateData({
        ...expiryDateData,
        extendedDate: recentPlanDetail?.EndDate,
      });
    }
  }, [recentPlanDetail]);

  async function handleUpdateUser(formValues) {
    const { password, confirmPassword } = formValues;
    if (password !== confirmPassword) {
      setFormValues({
        ...formValues,
        passwordError: "Password must be same",
      });
      return;
    } else {
      emptyPasswordError();
    }
    let payload = { ...formValues };

    // for every key in form values, if value is empty string , it should be set to null
    for (const key in formValues) {
      if (Object.hasOwnProperty.call(formValues, key)) {
        payload[key] = formValues[key] || null;
      }
    }
    try {
      await updateUser({
        params: { ...payload },
      });
      if (updateUserData?.message === "Success")
        message.success("Updated successfully");
    } catch (error) {
      console.log({ error });
    }
  }

  function emptyPasswordError() {
    setFormValues({
      ...formValues,
      passwordError: "",
    });
  }
  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const getEmailAndVideoNameFromUrl = (url) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL
    const lastPart = parts[parts.length - 1];
    // Remove the ".mp4" extension if it exists
    const videoName = lastPart.replace(".mp4", "");
    // Return an object containing the email and video name

    return generateVideoName(email, videoName);
  };
  const generateVideoName = (userEmail, videoName) => {
    return `${userEmail}/${videoName}`;
  };
  function getClickedVideo(video) {
    sethistoryVideo(video);
    const localFileId = getEmailAndVideoNameFromUrl(video?.url);
    setfileId(localFileId);
  }

  return (
    <Modal
      closeIcon={<ModalCloseIcon />}
      className={styles.userSubscriptionDetail}
      open={showUserSubscDetailModal}
      onCancel={() => {
        handleCloseModal();
      }}
      footer={null}
      style={{
        maxWidth: "100%",
      }}
      centered
      styles={{
        body: {
          height: "97dvh",

          overflowY: currentSlide === 3 ? "auto" : "hidden",
        },
        content: {
          padding: "20px 20px 5px 20px",
        },
      }}
      width="97vw"
      destroyOnClose={true}
    >
      <ConditionalRenderer
        condition={
          currentSlide === 0 || currentSlide === 1 || currentSlide === 2
        }
      >
        <NextIcon className={styles.nextIcon} onClick={handleNext} />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={
          currentSlide === 1 ||
          currentSlide === 2 ||
          currentSlide === 3 ||
          currentSlide === 4 ||
          currentSlide === 5
        }
      >
        <PreviousIcon className={styles.previousIcon} onClick={handlePrev} />
      </ConditionalRenderer>

      <Carousel
        dots={false}
        ref={sliderRef}
        infinite={false}
        className={styles.carouselContainer}
        beforeChange={handleBeforeChange}
      >
        <ConditionalRenderer condition={currentSlide === 0}>
          <Spin spinning={userDetailsLoading}>
            <h3 className={styles.heading}>Overview</h3>

            <div className={styles.detailsContainer}>
              <PersonalDetails
                userDetails={userDetails?.user}
                address={userDetails?.addresses?.[0]}
                getUsers={getUsers}
                page={page}
                size={size}
                search={search}
                currentSubscription={currentSubscription}
                currentSubscriptionLoading={currentSubscriptionLoading}
                currentSubscriptionRefetch={currentSubscriptionRefetch}
                currentPlanObj={currentPlanObj}
                userDetailsRefetch={userDetailsRefetch}
              />
              <CaptureDetails
                userSubscriptionHistory={userSubscriptionHistory}
                isLoading={isLoading}
                userDetails={userDetails?.user}
                currentSubscription={currentSubscription?.subscription}
                currentPlanObj={currentPlanObj}
                currentSubscriptionRefetch={currentSubscriptionRefetch}
              />
            </div>
          </Spin>
        </ConditionalRenderer>
        <ConditionalRenderer condition={currentSlide === 1}>
          <StrikersList
            userID={userId}
            handleNext={handleNext}
            goTo={goTo}
            setIsStrikerSelected={setIsStrikerSelected}
          />
        </ConditionalRenderer>
        <ConditionalRenderer condition={currentSlide === 2}>
          <UserHistory
            connectedStrikerId={userId}
            handleNext={handleNext}
            getClickedVideo={getClickedVideo}
            goTo={goTo}
          />
        </ConditionalRenderer>

        <ConditionalRenderer condition={currentSlide === 3}>
          <Preview
            fileId={fileId}
            visible
            givenPathName="/m2c-golf-history"
            swingType="Full Swing"
            sportName="Golf"
            // sportName={videoData?.sportName}
          />
        </ConditionalRenderer>
        <ConditionalRenderer condition={currentSlide === 4}>
          <CommunicationReasons
            heightOfTicketContainer="80dvh"
            handleNext={handleNext}
          />
        </ConditionalRenderer>
        <ConditionalRenderer condition={currentSlide === 5}>
          <Activity />
        </ConditionalRenderer>
      </Carousel>
    </Modal>
  );
};
